import StatesMarquee from '../StatesMarquee';
import { WavyBackground } from './WavyBackground';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';

export const SiteLayout = ({ children, testid }) => (
  <div className="site-root relative min-h-screen" data-testid={testid}>
    <WavyBackground />
    <div className="relative z-10">
      <StatesMarquee />
      <SiteHeader />
      <main>{children}</main>
    </div>
    <SiteFooter />
  </div>
);
